var vendorDocumentsArray = [];
var eachDocImageValid = [];
var mandatoryDocsId = [];
var documentIdArray = [];
var vendorAWSURL = "";
var vendorDetailsforAdminEmail = [];

import { getImageUrl, getVendorBusinessImageUrl } from "../helpers/mediaUrl";



const isBusinessPhotoDoc = (documentName) => {
  if (!documentName) return false;
  const lower = documentName.toLowerCase();
  return lower.includes("business photo") || lower.includes("business image");
};

export default class Vendor_upload_documents {
  constructor() {
    //
    this.formstep1 = $("#formstep1");
    this.formstep2 = $("#formstep2");
    this.formstep3 = $("#formstep3");
    this.formstep4 = $("#formstep4");
    this.formstep5 = $("#formstep5");

    this.productServicesListingPage = $(".product-services-listing-page");
    this.uploadPrevBtn = $("#uploadPrevBtn");
    this.uploadDocsSubmitBtn = $(".uploadDocsSubmitBtn");
    this.uploadDocuments_page5 = $(".vendorUploadDocuments");
    this.listingPageSmtBtn = $("#listingPageSmtBtn");
    this.Products_Services_page4 = $(".Products-Services-page4"); //not used ?

    // Registering Events
    this.bindEvents();
  }

  bindEvents = () => {
    //
    this.listingPageSmtBtn.on("click", this.getRequiredVendorDocuments);
    this.uploadDocsSubmitBtn.on("click", this.doDocumentValidation);
    this.uploadPrevBtn.on("click", this.UploadDocPagePrevAction);
  };
  getRequiredVendorDocuments = () => {
    $.ajax({
      type: "GET",
      url: baseURL + "api/vendor/RequiredVendorDocuments",
      headers: { Authorization: X_API_KEY },

      success: this.showRequiredDocuments,
    });
  };
  // To go to Previous Page (Product Listing)
  UploadDocPagePrevAction = (e) => {
    e.preventDefault();
    //
    this.productServicesListingPage.removeClass("d-none");
    this.uploadDocuments_page5.addClass("d-none");
    this.formstep5.removeClass("current-item");
    this.formstep4.addClass("current-item");
  };

  // To validate if all manditory document images are submitted
  doDocumentValidation = (e) => {
    //
    //
    //
    //
    e.preventDefault();
    var mandatoryDocsImagealid = true;
    mandatoryDocsId.forEach((element) => {
      //
      //
      if (eachDocImageValid[element] == false) {
        //
        $("#collapseOne-4").addClass("show");

        const docFileInputPrev = document.getElementsByClassName(element);
        docFileInputPrev[1].innerHTML = "Please select an image file";
        mandatoryDocsImagealid = false;
      }
    });

    if (mandatoryDocsImagealid) {
      //
      this.Submit_VendorDocuments();
    }
  };

  // Vendor Documents submit function
  Submit_VendorDocuments = async () => {
    // 1. Get vendor details for admin email and vendorID
    let vendorID = null;
    await new Promise((resolve) => {
      $.ajax({
        type: "GET",
        url: baseURL + "api/vendor/getVendorDetails",
        headers: { Authorization: X_API_KEY },
        success: (res) => {
          const resolvedVendorID = res.vendor?.Vendor_ID || res.Vendor_ID;
          vendorAWSURL = getVendorBusinessImageUrl(res.Image_URL, 1);
          vendorDetailsforAdminEmail = res;
          vendorID = resolvedVendorID;
          resolve();
        },
        error: resolve,
      });
    });

    if (!vendorID) {
      console.error("VendorID not found!");
      return;
    }

    // 2. Build FormData with actual document files
    const formData = new FormData();
    let attachedFiles = 0;
    for (const element of documentIdArray) {
      const input = document.getElementById(element);
      const file = input ? input.files[0] : null;
      if (file) {
        formData.append(element, file);
        attachedFiles++;
      }
    }
    formData.append("Vendor_ID", vendorID);

    if (attachedFiles === 0) {
      console.error("No files selected for upload");
      $("#collapseOne-4").addClass("show");
      return;
    }

    // 3. Upload documents via uploadDocuments API
    try {
      const uploadRes = await fetch(baseURL + "api/vendor/uploadDocuments", {
        method: "POST",
        headers: { Authorization: X_API_KEY },
        body: formData,
      });
      const uploadData = await uploadRes.json();
      console.log("Document upload response:", uploadData);
      if (!uploadRes.ok) {
        console.error("Document upload failed:", uploadData);
        $("#collapseOne-4").addClass("show");
        return;
      }
    } catch (err) {
      console.error("Document upload failed:", err);
      $("#collapseOne-4").addClass("show");
      return;
    }

    // 4. Mark vendor as submitted
    var DocCurrentThis = this;
    await new Promise((resolve) => {
      $.ajax({
        type: "POST",
        url: baseURL + "api/Vendor/submit",

        headers: { Authorization: X_API_KEY },

        success: (res) => {
          this.sendAdminEmailToVerifyNewVendor();
          resolve();
        },
        error: resolve,
      });
    });

    // 5. Redirect to summary page
    $.ajax({
      type: "GET",
      url: baseURL + "api/Vendor/getVendorSummary",

      headers: { Authorization: X_API_KEY },

      success: this.vendorDataID,
    });
  };

  // To load Summary page using vendor Id
  vendorDataID = (res) => {
    //
    // var Vendor_ID = "67ccb451-4497-11e9-b548-778fd1e3dff0";
    var Vendor_ID = res.vendor["Vendor_ID"];
    //
    //window.location.replace(baseURL + "Vendor_summary/index/" + Vendor_ID);

    //TO GO TO NEXT PAGE
    window.location.replace(baseURL + "Vendor_summary/index/" + Vendor_ID);
  };

  // To integrate the documents on the page
  showRequiredDocuments = (res) => {
    console.log(res);
    $("#vendorDocBox").empty();
    mandatoryDocsId = [];
    eachDocImageValid = [];
    documentIdArray = [];
    //
    var mandatoryDocsCount = 0;

    res.forEach((element) => {
      console.log("DOCUMENT OBJECT:", element);
      if (element.Mandatory_flag == 1) {
        mandatoryDocsId[mandatoryDocsCount] = element.Document_ID;
        mandatoryDocsCount++;
      }
      var mandatorylabel = element.Mandatory_flag == 1 ? "&nbsp*" : "";
      var nextDocument = `<div class="row mb-3">
                          <div><label class="form-label">${element.Document_Name}</label><label class="text-danger">${mandatorylabel}</label></div>
                          <input type="file" class="form-control inputVendorDocument" id="${element.Document_ID}" accept=".jpg,.jpeg,.png,.webp,.pdf" name="inpFile" aria-describedby="" value='${element.Mandatory_flag}'>
                          <br>
                          <img src="" alt="" id="" class="${element.Document_ID}" width="220px" height="auto" value='${element.Document_Name}'>
                          <div class="docImageError text-danger ${element.Document_ID}"></div>
                          <br>
                          </div>`;
      $("#vendorDocBox").append(nextDocument);
      const docFileInput = document.getElementById(element.Document_ID);
      docFileInput.addEventListener("change", this.isDocumentImmage);
      eachDocImageValid[element.Document_ID] = false;
      documentIdArray.push(element.Document_ID);
      if (element.Document_URL) {
        this.insertDocImg(element.Document_ID, element.Document_URL);
      } else if (isBusinessPhotoDoc(element.Document_Name)) {
        this.insertDocImg(element.Document_ID, vendorAWSURL);
      }
    });
  };

  insertDocImg = (imgTagClassName, path) => {
    const el = document.getElementsByClassName(imgTagClassName)[0];
    if (!el || !path) return;
    el.src = getImageUrl(path);
  };

  // Validation to check if the Document is in image form
  isDocumentImmage = (e) => {
    //
    //
    var docImagePreview = e.target.id;
    const docFileInputPrev = document.getElementsByClassName(docImagePreview);
    //
    //
    docFileInputPrev[0].src = "";
    eachDocImageValid[docImagePreview] = false;

    //
    if (!e.target.files.length) {
      return;
    }

    var fileExpression = /.*\.(jpg|jpeg|png|webp|pdf|JPG|JPEG|PNG|WEBP|PDF)$/;
    if (!e.target.files[0]) {
    } else {
      if (
        !e.target.files[0]["name"].match(fileExpression) ||
        !e.target.files[0]["name"]
      ) {
        $("#collapseOne-4").addClass("show");

        docFileInputPrev[1].innerHTML =
          "Please select JPG, JPEG, PNG, WEBP or PDF file";
      } else if (e.target.files[0]["size"] > 5 * 1024 * 1024) {
        $("#collapseOne-4").addClass("show");

        docFileInputPrev[1].innerHTML = "Document should be less than 5mb";
      } else {
        //
        eachDocImageValid[docImagePreview] = true;

        docFileInputPrev[1].innerHTML = "";

        if (
          e.target.files[0] &&
          (e.target.files[0].type || "").toLowerCase().startsWith("image/")
        ) {
          const reader = new FileReader();

          reader.addEventListener("load", function () {
            // Storing image in Preview
            docFileInputPrev[0].src = this.result;
          });

          reader.readAsDataURL(e.target.files[0]);
        }
      }
    }
  };

  sendAdminEmailToVerifyNewVendor = async (e) => {
    if (true) {
      var BodyHtmlForAdmin = `<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">
      <html>
        <head>
          <!-- Compiled with Bootstrap Email version: 1.3.1 -->
          <meta http-equiv="Content-Type" content="text/html; charset=utf-8">
          <meta http-equiv="x-ua-compatible" content="ie=edge">
          <meta name="x-apple-disable-message-reformatting">
          <meta name="viewport" content="width=device-width, initial-scale=1">
          <meta name="format-detection" content="telephone=no, date=no, address=no, email=no">
          <style type="text/css">
            body,table,td{font-family:Helvetica,Arial,sans-serif !important}.ExternalClass{width:100%}.ExternalClass,.ExternalClass p,.ExternalClass span,.ExternalClass font,.ExternalClass td,.ExternalClass div{line-height:150%}a{text-decoration:none}{color:inherit}a[x-apple-data-detectors],u+#body a,#MessageViewBody a{color:inherit;text-decoration:none;font-size:inherit;font-family:inherit;font-weight:inherit;line-height:inherit}img{-ms-interpolation-mode:bicubic}table:not([class^=s-]){font-family:Helvetica,Arial,sans-serif;mso-table-lspace:0pt;mso-table-rspace:0pt;border-spacing:0px;border-collapse:collapse}table:not([class^=s-]) td{border-spacing:0px;border-collapse:collapse}@media screen and (max-width: 600px){.w-lg-48,.w-lg-48>tbody>tr>td{width:auto !important}.w-full,.w-full>tbody>tr>td{width:100% !important}.w-16,.w-16>tbody>tr>td{width:64px !important}.p-lg-10:not(table),.p-lg-10:not(.btn)>tbody>tr>td,.p-lg-10.btn td a{padding:0 !important}.p-2:not(table),.p-2:not(.btn)>tbody>tr>td,.p-2.btn td a{padding:8px !important}.pr-4:not(table),.pr-4:not(.btn)>tbody>tr>td,.pr-4.btn td a,.px-4:not(table),.px-4:not(.btn)>tbody>tr>td,.px-4.btn td a{padding-right:16px !important}.pl-4:not(table),.pl-4:not(.btn)>tbody>tr>td,.pl-4.btn td a,.px-4:not(table),.px-4:not(.btn)>tbody>tr>td,.px-4.btn td a{padding-left:16px !important}.pr-6:not(table),.pr-6:not(.btn)>tbody>tr>td,.pr-6.btn td a,.px-6:not(table),.px-6:not(.btn)>tbody>tr>td,.px-6.btn td a{padding-right:24px !important}.pl-6:not(table),.pl-6:not(.btn)>tbody>tr>td,.pl-6.btn td a,.px-6:not(table),.px-6:not(.btn)>tbody>tr>td,.px-6.btn td a{padding-left:24px !important}.pt-8:not(table),.pt-8:not(.btn)>tbody>tr>td,.pt-8.btn td a,.py-8:not(table),.py-8:not(.btn)>tbody>tr>td,.py-8.btn td a{padding-top:32px !important}.pb-8:not(table),.pb-8:not(.btn)>tbody>tr>td,.pb-8.btn td a,.py-8:not(table),.py-8:not(.btn)>tbody>tr>td,.py-8.btn td a{padding-bottom:32px !important}*[class=s-lg-]>tbody>tr>td{font-size:0 !important;line-height:0 !important;height:0 !important}.s-4>tbody>tr>td{font-size:16px !important;line-height:16px !important;height:16px !important}.s-6>tbody>tr>td{font-size:24px !important;line-height:24px !important;height:24px !important}}
          </style>
        </head>
        <body class="bg-red-100" style="outline: 0; width: 100%; min-width: 100%; height: 100%; -webkit-text-size-adjust: 100%; -ms-text-size-adjust: 100%; font-family: Helvetica, Arial, sans-serif; line-height: 24px; font-weight: normal; font-size: 16px; -moz-box-sizing: border-box; -webkit-box-sizing: border-box; box-sizing: border-box; color: #000000; margin: 0; padding: 0; border-width: 0;" bgcolor="#ff385c">
          <table class="bg-red-100 body" valign="top" role="presentation" border="0" cellpadding="0" cellspacing="0" style="outline: 0; width: 100%; min-width: 100%; height: 100%; -webkit-text-size-adjust: 100%; -ms-text-size-adjust: 100%; font-family: Helvetica, Arial, sans-serif; line-height: 24px; font-weight: normal; font-size: 16px; -moz-box-sizing: border-box; -webkit-box-sizing: border-box; box-sizing: border-box; color: #000000; margin: 0; padding: 0; border-width: 0;" bgcolor="#ff385c">
            <tbody>
              <tr>
                <td valign="top" style="line-height: 24px; font-size: 16px; margin: 0;" align="left" bgcolor="#ff385c">
                  <table class="container" role="presentation" border="0" cellpadding="0" cellspacing="0" style="width: 100%;">
                    <tbody>
                      <tr>
                        <td align="center" style="line-height: 24px; font-size: 16px; margin: 0; padding: 0 16px;">
                          <!--[if (gte mso 9)|(IE)]>
                            <table align="center" role="presentation">
                              <tbody>
                                <tr>
                                  <td width="600">
                          <![endif]-->
                          <table align="center" role="presentation" border="0" cellpadding="0" cellspacing="0" style="width: 100%; max-width: 600px; margin: 0 auto;">
                            <tbody>
                              <tr>
                                <td style="line-height: 24px; font-size: 16px; margin: 0;" align="left">
                                  <table class="s-6 w-full" role="presentation" border="0" cellpadding="0" cellspacing="0" style="width: 100%;" width="100%">
                                    <tbody>
                                      <tr>
                                        <td style="line-height: 24px; font-size: 24px; width: 100%; height: 24px; margin: 0;" align="left" width="100%" height="24">
                                          &#160;
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                  <img class="w-16" src="https://locaso-pro-data-public.s3.ap-south-1.amazonaws.com/Public_Pictures/locasoWhiteWithoutOrange.png" style="height: auto; line-height: 100%; outline: none; text-decoration: none; display: block; width: 64px; border-style: none; border-width: 0;" width="64">
                                  <table class="s-6 w-full" role="presentation" border="0" cellpadding="0" cellspacing="0" style="width: 100%;" width="100%">
                                    <tbody>
                                      <tr>
                                        <td style="line-height: 24px; font-size: 24px; width: 100%; height: 24px; margin: 0;" align="left" width="100%" height="24">
                                          &#160;
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                  <div class="space-y-4">
                                    <h1 class="text-4xl fw-800" style="padding-top: 0; padding-bottom: 0; font-weight: 800 !important; vertical-align: baseline; font-size: 36px; line-height: 43.2px; margin: 0;" align="left">${
                                      vendorDetailsforAdminEmail.Business_Name
                                    } has COMPLETED the registration as a new Seller</h1>
                                    <table class="s-4 w-full" role="presentation" border="0" cellpadding="0" cellspacing="0" style="width: 100%;" width="100%">
                                      <tbody>
                                        <tr>
                                          <td style="line-height: 16px; font-size: 16px; width: 100%; height: 16px; margin: 0;" align="left" width="100%" height="16">
                                            &#160;
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                    <p class="" style="line-height: 24px; font-size: 16px; width: 100%; margin: 0;" align="left">Log in to your Admin dashboard to verify andupdate the status of the vendor.</p>
                                    <table class="s-4 w-full" role="presentation" border="0" cellpadding="0" cellspacing="0" style="width: 100%;" width="100%">
                                      <tbody>
                                        <tr>
                                          <td style="line-height: 16px; font-size: 16px; width: 100%; height: 16px; margin: 0;" align="left" width="100%" height="16">
                                            &#160;
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                    <table class="btn btn-red-500 rounded-full px-6 w-full w-lg-48" role="presentation" border="0" cellpadding="0" cellspacing="0" style="border-radius: 9999px; border-collapse: separate !important; width: 192px;" width="192">
                                      <tbody>
                                        <tr>
                                          <td style="line-height: 24px; font-size: 16px; border-radius: 9999px; width: 192px; margin: 0;" align="center" bgcolor="#dc3545" width="192">
                                            <a href="${
                                              baseURL +
                                              "locaso-admin-api/Login/index"
                                            }" style="color: #ffffff; font-size: 16px; font-family: Helvetica, Arial, sans-serif; text-decoration: none; border-radius: 9999px; line-height: 20px; display: block; font-weight: normal; white-space: nowrap; background-color: #3335ec; padding: 8px 24px; border: 1px solid #3335ec;">Dashboard</a>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                  <table class="s-6 w-full" role="presentation" border="0" cellpadding="0" cellspacing="0" style="width: 100%;" width="100%">
                                    <tbody>
                                      <tr>
                                        <td style="line-height: 24px; font-size: 24px; width: 100%; height: 24px; margin: 0;" align="left" width="100%" height="24">
                                          &#160;
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                  <table class="card rounded-3xl px-4 py-8 p-lg-10" role="presentation" border="0" cellpadding="0" cellspacing="0" style="border-radius: 24px; border-collapse: separate !important; width: 100%; overflow: hidden; border: 1px solid #e2e8f0;" bgcolor="#ffffff">
                                    <tbody>
                                      <tr>
                                        <td style="line-height: 24px; font-size: 16px; width: 100%; border-radius: 24px; margin: 0; padding: 40px;" align="left" bgcolor="#ffffff">
                                          <h3 class="text-center" style="padding-top: 0; padding-bottom: 0; font-weight: 500; vertical-align: baseline; font-size: 28px; line-height: 33.6px; margin: 0;" align="center">Vendor Details</h3>
                                          <p class="text-center text-muted" style="line-height: 24px; font-size: 16px; color: #718096; width: 100%; margin: 0;" align="center">Vendor  ID #${
                                            vendorDetailsforAdminEmail.Vendor_ID
                                          }</p>
                                          <table class="p-2 w-full" border="0" cellpadding="0" cellspacing="0" style="width: 100%;" width="100%">
                                            <tbody>
                                              ${""}
                                            </tbody>
                                          </table>
                                          <table class="s-6 w-full" role="presentation" border="0" cellpadding="0" cellspacing="0" style="width: 100%;" width="100%">
                                            <tbody>
                                              <tr>
                                                <td style="line-height: 24px; font-size: 24px; width: 100%; height: 24px; margin: 0;" align="left" width="100%" height="24">
                                                  &#160;
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                          <table class="hr" role="presentation" border="0" cellpadding="0" cellspacing="0" style="width: 100%;">
                                            <tbody>
                                              <tr>
                                                <td style="line-height: 24px; font-size: 16px; border-top-width: 1px; border-top-color: #e2e8f0; border-top-style: solid; height: 1px; width: 100%; margin: 0;" align="left">
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                          <table class="s-6 w-full" role="presentation" border="0" cellpadding="0" cellspacing="0" style="width: 100%;" width="100%">
                                            <tbody>
                                              <tr>
                                                <td style="line-height: 24px; font-size: 24px; width: 100%; height: 24px; margin: 0;" align="left" width="100%" height="24">
                                                  &#160;
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                          <p style="line-height: 24px; font-size: 16px; width: 100%; margin: 0;" align="left">If you have any questions, contact us at <a href="https://bootstrapemail.com" style="color: #0d6efd;"><span class="_cf_email_" data-cfemail="40082930032f3230002538212d302c256e232f2d">vendor.support@locaso.com</span></a>.</p>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                  <table class="s-6 w-full" role="presentation" border="0" cellpadding="0" cellspacing="0" style="width: 100%;" width="100%">
                                    <tbody>
                                      <tr>
                                        <td style="line-height: 24px; font-size: 24px; width: 100%; height: 24px; margin: 0;" align="left" width="100%" height="24">
                                          &#160;
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <!--[if (gte mso 9)|(IE)]>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                          <![endif]-->
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
        <script data-cfasync="false" src="/cdn-cgi/scripts/5c5dd728/cloudflare-static/email-decode.min.js"></script></body>
      </html>`;
      $.ajax({
        url: baseURL + "api/AmazonSesSmtp/sendEmail",
        type: "POST",
        data: {
          SenderAddress: "vendor.support@locaso.com",
          ReceiverAddress: "vendor.support@locaso.com",
          Subject: `REGISTRATION COMPLETE - new supplier has completed registration on Locaso`,
          BodyText: `VENDOR REGISTRATION DETAILS`,
          BodyHtml: BodyHtmlForAdmin,
        },
        success: (result) => {},
        error: (error) => {},
      });
    }
  };
}

